import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getArticleById } from "../../HTTP/articles";
import { updateVisibleArticle } from "../../HTTP/admin";

export default function CheckArticle() {
    const user = JSON.parse(localStorage.getItem("user"))
    if (!user.admin) {
        window.location.href = "/"
    }
    const { id } = useParams()
    const [formData, setFormData] = useState({
        id: id,
        user_id: user.id,
        title: '',
        description: '',
        visible: 0
    });

    useEffect(() => {
        const funArticles = async () => {
            const resArticle = await getArticleById(id)
            setFormData(resArticle)
        }
        funArticles()
      }, [id])
      
      const handlePublishArticle = async () => {
        const res = await updateVisibleArticle(id, 3, "")
        if (res) {
            alert("Article accepted")
            window.location.href = "/admin/articles"
        } else {
            alert("An error occured while accepting the article")
        }
      }

      const handleRefuseArticle = async () => {
        const comment = prompt("Give a reason for refusal : ")
        if (comment) {
            const res = await updateVisibleArticle(id, 0, comment)
            if (res) {
                alert("Article accepted")
                window.location.href = "/admin/articles"
            } else {
                alert("An error occured while accepting the article")
            }
        }
      }

      if (formData.visible === 0 && user.admin === 0 && user.id !== formData.user_id) {
        window.location.href = "/articles"
      }

    return (
        <>
            <div className="mt-8 max-w-md mx-auto p-6 bg-white rounded-lg shadow-md md:overflow-y-auto" style={{ maxHeight: window.innerWidth >= 768 ? 'calc(100vh - 100px)' : undefined }}>
                <h1 className="text-2xl font-semibold text-gray-800 text-center">Vérification de l'article</h1>
                {
                    formData.featured_image && (
                        <>
                        <h2 className="text-xl font-semibold text-gray-800 mt-8 text-center">Image à la une</h2>
                        <img className="w-full h-auto max-h-[60vh] object-cover" src={formData.featured_image} alt="Article" />
                        </>
                    )
                }
                <h2 className="text-xl font-semibold text-gray-800 mt-8 text-center">Titre de l'article</h2>
                <h3 className="text-lg font-semibold text-gray-800 mt-2 text-center notranslate">{formData.title}</h3>
                <h2 className="text-xl font-semibold text-gray-800 mt-8 text-center">Description de l'article</h2>
                <div className="max-w-2xl mx-auto mt-4 p-6 bg-white shadow-md max-h-[60vh] overflow-y-auto notranslate" dangerouslySetInnerHTML={{ __html: formData.description }} />

                <div className="max-w-2xl mx-auto flex flex-col items-center"> {/* Conteneur pour aligner l'input et les boutons */}
                    <div className="flex flex-col sm:flex-row sm:justify-center gap-3 mt-4">
                        <button className="px-4 py-2 bg-green-500 text-white rounded hover:bg-green-600" onClick={handlePublishArticle}>
                            Accepter
                        </button>
                        <button className="px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600" onClick={handleRefuseArticle}>
                            Refuser
                        </button>
                    </div>
                </div>
            </div>
        </>
    )
}